// src/pages/auth/VerifyEmailPage.tsx
import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { verifyEmailChange } from '@/lib/services/auth';
import { brand } from '@/lib/tokens';

export function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      return;
    }
    verifyEmailChange(token)
      .then(() => {
        setStatus('success');
        setTimeout(() => navigate('/settings'), 3000);
      })
      .catch(() => setStatus('error'));
  }, [searchParams, navigate]);

  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--color-canvas-warm)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'Manrope, sans-serif',
      color: 'var(--color-on-surface)',
    }}>
      <div style={{
        textAlign: 'center',
        padding: 40,
        maxWidth: 400,
      }}>
        {status === 'loading' && (
          <>
            <p style={{ fontSize: 18, marginBottom: 8 }}>Verifying your email...</p>
          </>
        )}
        {status === 'success' && (
          <>
            <p style={{ fontSize: 24, marginBottom: 8, color: 'var(--color-success)' }}>Email updated successfully</p>
            <p style={{ color: 'rgba(var(--fg-rgb),0.6)' }}>Redirecting to settings...</p>
          </>
        )}
        {status === 'error' && (
          <>
            <p style={{ fontSize: 24, marginBottom: 8, color: '#fbb4ab' }}>Verification failed</p>
            <p style={{ color: 'rgba(var(--fg-rgb),0.6)', marginBottom: 24 }}>
              The link may be invalid or expired.
            </p>
            <button
              onClick={() => navigate('/settings')}
              style={{
                background: brand.accent,
                color: brand.canvasWarm,
                border: 'none',
                padding: '10px 24px',
                borderRadius: 8,
                cursor: 'pointer',
                fontFamily: 'Manrope, sans-serif',
                fontWeight: 600,
              }}
            >
              Back to Settings
            </button>
          </>
        )}
      </div>
    </div>
  );
}
